import { ref } from 'vue'

export const currentPaginationPage = ref(1)

export const setCurrentPaginationPage = (page: number):void => {
    currentPaginationPage.value = page
}

export const maxAmountPaginationPages = ref(1)

export const setMaxAmountPaginationPages = (page: number):void => {
    maxAmountPaginationPages.value = page
}